import { Link } from 'react-router-dom';
import { Stack, Button } from '@mui/material';
import { dateFormmater, urlGetCertificationByWorkId } from '../../../helpers';
import useFecth from '../../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';

export const ViewCertificationWork = ({ workId }) => {

    const { data } = useFecth(`${urlGetCertificationByWorkId}?id=${workId}`, 'get')

    return (
        <Stack direction='row' justifyContent='space-around' flexWrap='wrap' gap={3} widt='95%'>

                {
                    data
                        ? data.map(cert => (
                                <Link
                                    to={'/viewCertification?id=' + cert.id}
                                    style={{ textDecoration: 'none' }}
                                    key={cert.id}
                                >
                                    <Button color="primary" >
                                        {dateFormmater(cert.firstDate)} - {dateFormmater(cert.lastDate)}
                                    </Button>
                                </Link>
                        ))
                        : <CircularProgress />
                }

        </Stack >
    )
}
